import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetUsers = (params) => {
    return async (dispatch, getState) => {
        try {
            params.search = params.search.replace(/\s/g, '').toLowerCase();
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_USERS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetUsersAction({
                    data: data.data,
                    countPage: data.countPage
                }));
                dispatch(Action.SetLoadingAction(false))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetUsers as SetGetUsers
}